import LoginPageStyleFooter from './LoginPageStyleFooter';

export default LoginPageStyleFooter;
